import { hasAnyRole } from '@/api/common/auth/utils';
import type { RoleCode } from '@/consts/roles';
import { ROUTES } from '@/consts/routes';
import { selectUser, useAuthStore } from '@/stores/useAuthStore';
import { Navigate, Outlet } from 'react-router';

interface RoleGuardProps {
  requiredRoles: RoleCode[];
}

export const RoleGuard = ({ requiredRoles }: RoleGuardProps) => {
  const user = useAuthStore(selectUser);

  if (!hasAnyRole(user, requiredRoles)) {
    return <Navigate to={ROUTES.auth.unauthorized} replace />;
  }

  return <Outlet />;
};
